export class UpdatePoolConnectionSettingsRequestModel {
  clientCreationAutoSyncOn: 'CLIENT' | 'ADVISOR';
  clientUpdateAutoSyncOn: 'CLIENT' | 'ADVISOR';
  clientDeletionAutoSyncOn: 'CLIENT' | 'ADVISOR';
  autoCreateMandate: boolean;
  createVinlivtClientOnSync: boolean;
  recreateClientInPoolOnSync: boolean;
  createClientInPoolOnSync: boolean;
  matchProperties: ('FIRST_NAME' | 'LAST_NAME' | 'BIRTH_DATE' | 'ADDRESS' | 'EMAIL' | 'PHONE_NUMBER' | 'TAX_ID')[];
}

export class UpdatePoolConnectionInformationRequestModel {
  type: string;
  username: string;
  subdomain?: string;
  password: string;
}
